import { render, staticRenderFns } from "./solutionDetails.vue?vue&type=template&id=5ed1089c&scoped=true&"
import script from "./solutionDetails.vue?vue&type=script&lang=js&"
export * from "./solutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails.vue?vue&type=style&index=0&id=5ed1089c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1089c",
  null
  
)

export default component.exports